// Gruppo di schede radio con tabindex mobile (pattern WAI-ARIA): una sola scheda è nella
// sequenza del Tab. È quella col focus mentre ci si muove con le frecce; uscendo dal gruppo
// si rientra sulla scheda scelta, oppure sulla prima se nessuna lo è.
export const getTabStopId = (
  ids: string[],
  checkedId: string | undefined,
  focusedId: string | undefined
): string | undefined => {
  if (focusedId !== undefined && ids.includes(focusedId)) return focusedId;
  if (checkedId !== undefined && ids.includes(checkedId)) return checkedId;
  return ids[0];
};

// Frecce giù e destra: scheda successiva; su e sinistra: precedente. Dall'ultima si riparte
// dalla prima e viceversa. Con altri tasti, o senza una scheda di partenza, il focus resta.
export const getArrowTargetIndex = (
  key: string,
  index: number,
  count: number
): number | undefined => {
  if (index < 0 || index >= count) return undefined;
  if (key === 'ArrowDown' || key === 'ArrowRight') return (index + 1) % count;
  if (key === 'ArrowUp' || key === 'ArrowLeft') {
    return (index - 1 + count) % count;
  }
  return undefined;
};
